import supportedChains, { chains } from './chains';

export const getChainById = (id: number) => chains.find(c => c.id === id);

export const getSupportedChainById = (id: number) => supportedChains.find(c => c.id === id);

export const getSupportedChainByRoutePrefix = (routePrefix: string) =>
  supportedChains.find(c => c.routePrefix === routePrefix);
